import React, { lazy, Suspense } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { history } from "_helpers";
import { Nav, Alert, PrivateRoute, PageLoader } from "_components";
import { Home } from "home";
import { AccountLayout } from "account";
import { SupplierCenteralHome } from "supplier-centeral/home/index";
import { NewsRoom } from "supplier-centeral/NewsRoom";
import { NewsRoomDetails } from "supplier-centeral/NewsRoom/NewsRoomDetails";
import { Toast } from "./_components/ToastContainer";

import { AdminHome, AdminUserList, UserCreation, MyAccount, PerformaInvoice, JobsList } from "admin/index";

export { App };

const AppLayout = lazy(() =>
  import(/*webpackChunkName:'AppLayout'*/ "./app/AppLayout")
);

function App() {
  history.navigate = useNavigate();
  history.location = useLocation();
  const isHome = history.location.pathname === "/";
  return (
    <Suspense fallback={<PageLoader />}>
      {isHome && <Nav />}
      <Alert />
      <>
        <Routes>
          {/* private */}
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Home />} />
            <Route path="/*" element={<AppLayout />} />
            <Route path="supplier-centeral-home/*" element={<SupplierCenteralHome />} />
            <Route path="news-room/*" element={<NewsRoom />} />
            <Route path="news-room-details/*" element={<NewsRoomDetails />} />

            {/*-ADMIN-*/}
            <Route path="admin-home/*" element={<AdminHome />} />
            <Route path="admin-user-list" element={<AdminUserList />} />
            <Route path="admin-user-list/user-creation" element={<UserCreation />} />
            <Route path="admin-user-list/:userId" element={<UserCreation />} />
            {/*- commencting for uat
            <Route path="performa-invoice/*" element={<PerformaInvoice />} />
            */}
            <Route path="jobs-list" element={<JobsList />} />

          </Route>
          {/* public */}
          <Route path="account/*" element={<AccountLayout />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </>
      <Toast />
    </Suspense>
  );
}
